import React, { useContext, useState, useEffect, useRef } from "react";
import { baseUrl, dataContext } from "../../App";
import "./Profile.css";
import avatarImg from "../../assets/img/leaderboard/avatar.png";
import scoreBgImg from "../../assets/img/v2/score_bg.png";
import ProfileEditModal from "../ProfileEditModal/ProfileEditModal";
import activityLogSubmission from "../../helper/activitylog";
import analyticEvent from "../../helper/gaEvent";
import { FaShare } from "react-icons/fa6";
import { pushCleverTapEvent } from "../../helper/clevertapFunction";
import ProfileUpper from "./ProfileUpper/ProfileUpper";
import EventScore from "./EventScore/EventScore";
import ReferralHistory from "./ReferralHistory/ReferralHistory";
import PlayingHistory from "../BannerPart3/PlayingHistory/PlayingHistory";
import SubscriptionStatus from "../Subscription/SubscriptionStatus/SubscriptionStatus";
import { fetchUserLeaderboard } from "../../services";

const Profile = ({ showLoginModal, setShowLoginModal, setShowReferModal, setActiveBottom, quizClickHandler }) => {
  const { token, setToken, playerData, setPlayerData, events, setEvents } =
    useContext(dataContext);
  const [showProfileEditModal, setShowProfileEditModal] = useState(false);
  const [playerLeaderboardData, setplayerLeaderboardData] = useState([]);
  const [playerNewYearData, setplayerNewYearData] = useState({score:0,User_Rank:0});

  useEffect(() => {
    if (playerData?.id) {
    } else {
      setShowLoginModal(true);
    }
    let msisdn = null;

    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("profile", msisdn);
    analyticEvent('profile', 'profile-view')
    // pushCleverTapEvent('CheckIn-Profile');
  }, []);

  useEffect(() => {
    if (token) {
      fetchUserLeaderboard(token).then((res) => {
        setplayerLeaderboardData(res?.leaderboard || []);
        setplayerNewYearData(res?.new_year_score || {score:0,User_Rank:0});
      });
    }
  }, [playerData]);
  

  return (
    <>
      <div className="profileWrapper">
        <ProfileUpper playerData={playerData} setShowProfileEditModal={setShowProfileEditModal} />
        <EventScore events={events} playerLeaderboardData={playerLeaderboardData} playerNewYearData={playerNewYearData} />
        <div className="subsCription" style={{ padding: '24px 16px' }}>
          <SubscriptionStatus
            setShowLoginModal={setShowLoginModal}
            isSubscribe={playerData?.isSubscribe}
            isSubscribeTournament={playerData?.isSubscribeTournament}
          />
        </div>
        <ReferralHistory />
        <PlayingHistory events={events} playerData={playerData} quizClickHandler={quizClickHandler} />
      </div>
      {showProfileEditModal && (
        <ProfileEditModal
          showProfileEditModal={showProfileEditModal}
          setShowProfileEditModal={setShowProfileEditModal}
        ></ProfileEditModal>
      )}
    </>
  );
};

export default Profile;
